module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/trash_CM.046c18f5.svg";